

































































































































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import leaveList from '@/views/leave/component/leaveList.vue';
import moment from 'moment';
import confirmDialog from '@/components/common/confirmDialog.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import { TrainClassDto, ClassState, TimeSlot, TrainingClassType, EditLeaveDto } from '@/api/models';
import { Dialog, Notify } from 'vant';
import UserModule from '@/store/modules/user';
import axios from 'axios';
import { guid } from '@/utils/util';
import { lowerFirst, upperFirst } from 'lodash';
@Component({ components: { leaveList, confirmDialog, confirmFeedback } })
export default class LeaveIndex extends Vue {
  showEndPopover: boolean = false; // 结束时间段显隐
  endTimeIntervalValue: string = '选择时段'; // 结束时间按钮文字
  timeIntervalValue: string = '选择时段'; // 开始时间按钮文字
  showPopover: boolean = false;
  actions: any = [
    { text: '上午', value: this.TimeSlot.上午 },
    { text: '下午', value: this.TimeSlot.下午 },
    { text: '晚上', value: this.TimeSlot.晚上 },
    { text: '全日', value: null },
  ];
  loading: boolean = false;
  finished: boolean = false;
  errorMsg: string = '';
  classItem: Partial<TrainClassDto> = {
    id: '',
    className: '',
  };
  showPickerClass: boolean = false;
  showPickerStartTime: boolean = false;
  showPickerEndTime: boolean = false;
  //确认对话框相关
  dialogShow: boolean = false;
  feedbackShow: boolean = false;
  dialogType: string = '';
  feedbackType: string = '';
  successStatu: boolean = false;
  //请假开始时间、结束时间确认框专用
  leaveStartTime: string = '';
  leaveEndTime: string = '';
  isDisabled: boolean = false;
  stuImgs: any = [];
  previewImg: any = '';
  form: EditLeaveDto = {
    id: '',
    startTime: '',
    endTime: '',
    days: 0,
    reason: '',
    endTimeSlot: null,
    startTimeSlot: null,
  };
  classColumns: TrainClassDto[] = [];

  get TimeSlot() {
    return models.TimeSlot;
  }

  mounted() {
    //从我的培训班点击请假进入
    if (this.$route.query.classItem) {
      this.classItem = JSON.parse(this.$route.query.classItem as any);
    }
    if (this.$route.query.leaveInfo) {
      const leaveInfo = JSON.parse(this.$route.query.leaveInfo as any);
      this.classItem.className = leaveInfo.className;
      Object.keys(this.form).forEach(k => {
        const key = lowerFirst(k);
        if (key in leaveInfo) this.form[k] = leaveInfo[key];
      });
      this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD');
      this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD');
      this.classItem.endDate = moment(leaveInfo.endClassDate).format('YYYY-MM-DD');
      this.classItem.startDate = moment(leaveInfo.startClassDate).format('YYYY-MM-DD');
    }
  }

  // 开始事件段选择事件
  onSelect(action) {
    if (!this.form.startTime) {
      return Notify('请先选择开始时间');
    }
    if (
      this.form.startTime === this.form.endTime &&
      this.form.endTimeSlot != null &&
      action.value > this.form.endTimeSlot
    ) {
      return Notify('时段超出范围');
    }
    this.form.startTimeSlot = action.value;
    this.timeIntervalValue = action.text;
    this.setDays();
  }

  // 结束时间段选择事件
  onEndSelect(val) {
    if (!this.form.endTime) {
      return Notify('请先选择结束时间');
    }
    if (this.form.startTime === this.form.endTime && val.value < this.form.startTimeSlot) {
      return Notify('时段超出范围');
    }
    this.form.endTimeSlot = val.value;
    this.endTimeIntervalValue = val.text;
    this.setDays();
  }

  daysChange({ target }) {
    let num = 0.5;
    let res = target.value % num;

    if (res != 0 || target.value > this.form.days) {
      Notify({
        type: 'primary',
        message: '请假天数必须是0.5的倍数或在请假日期范围内!',
        duration: 3000,
      });
      this.form.startTime = null;
      this.form.endTime = null;
      this.form.days = 0;
    } else {
      this.form.days = target.value;
    }
  }

  async getStuImg(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.stuImgs = data;
  }

  //提交表单
  onSubmit() {
    this.dialogType = '请假';
    this.computeDays();
  }

  //选择请假开始时间事件
  onSelectStartTime(value: any) {
    this.form.startTime = moment(value).format('YYYY-MM-DD');

    this.showPickerStartTime = false;
    this.setDays();
  }

  //选择请假结束时间事件
  onSelectEndTime(value: any) {
    this.form.endTime = moment(value).format('YYYY-MM-DD');
    this.showPickerEndTime = false;
    this.setDays();
  }

  setDays() {
    if (!this.form.endTime || !this.form.startTime) return;

    let currentDay =
      ({
        [TimeSlot.上午]: 2,
        [TimeSlot.下午]: 2,
        [TimeSlot.晚上]: 1,
      }[this.form.startTimeSlot] ?? 0) *
        0.5 +
      ({
        [TimeSlot.上午]: 1,
        [TimeSlot.下午]: 2,
        [TimeSlot.晚上]: 2,
      }[this.form.endTimeSlot] ?? 2) *
        0.5;

    if (this.form.startTimeSlot == null && this.form.endTimeSlot == null) {
      currentDay = 2;
    }
    const start = new Date(this.form.startTime).getTime();
    const end = new Date(this.form.endTime).getTime();

    if (
      start === end &&
      this.form.startTimeSlot &&
      this.form.endTimeSlot &&
      this.form.startTimeSlot === this.form.endTimeSlot
    ) {
      currentDay = 1.5;
    }

    if (start > end) {
      Dialog.alert({
        message: '开始时间不能大于结束时间',
      });
      this.form.startTime = null;
      this.form.endTime = null;
      this.form.days = 0;
      return false;
    } else {
      const days = (end - start) / 1000 / 60 / 60 / 24;
      this.form.days = days - 1 + currentDay;
    }
  }

  computeDays() {
    if (this.form.startTime && this.form.endTime) {
      let startTime: any = new Date(this.form.startTime);
      let endTime: any = new Date(this.form.endTime);
      if (startTime > endTime) {
        Dialog.alert({
          message: '开始时间不能大于结束时间',
        });
        this.form.startTime = null;
        this.form.endTime = null;
        this.form.days = 0;
        return false;
      } else {
        this.dialogShow = true;
        this.leaveStartTime = moment(this.form.startTime).format('YYYY-MM-DD');
        this.leaveEndTime = moment(this.form.endTime).format('YYYY-MM-DD');
      }
    } else {
      this.form.days = 0;
    }
  }

  //确认请假回调事件
  async confirmSubmit(val: any) {
    this.dialogShow = false;
    this.feedbackShow = true;
    //系统返回提交状态
    try {
      const { data, success, message } = await api.Leaves.editLeaveInfo_POST(this.form);
      if (success) {
        this.successStatu = true;
        Notify({
          message: '修改成功',
          type: 'success',
          duration: 1000,
        });
        // Notify({ type: 'success', message: '修改成功' });
        //请假成功，清空form
        // for (let k of Object.keys(this.form)) {
        //   Vue.delete(this.form, k);
        // }
        this.$router.push('/leaveApproval/index');
      } else {
        this.successStatu = false;
        this.errorMsg = message;
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
    this.feedbackType = '请假';
  }
  //取消请假回调事件
  confirmCancle() {
    this.dialogShow = false;
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
  //获取当前可请假的培训班数据源
  async getClasses() {
    //暂时用这个接口，到时候要修改
    //培训中或即将开始的培训班次可请假
    let pxzClass: any = [];
    let jjksClass: any = [];
    {
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: ClassState.培训中,
      });
      pxzClass = data!.items!;
    }
    {
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: ClassState.未报道,
      });
      jjksClass = data!.items!;
    }
    this.classColumns = [...pxzClass, ...jjksClass];
  }
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
